import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import ExpenseForm from "./_form"

interface CaseRecord {
  id: number
  case_number: string
  display_name: string
}

interface ExpenseRecord {
  id?: number
  user_id: number | null
  expense_date: string | null
  expense_type: string
  expense_type_ref_id: number | null
  paid_to: string
  amount: number | string
  provider: string
  city: string
  state: string
  notes: string
  paid_by: string
  fuel_vehicle: string
  fuel_start_odometer: number
  fuel_end_odometer: number
  room_number: number | null
  stay_start: string | null
  stay_end: string | null
  rental_make: string
  rental_model: string
  rental_color: string
  rental_tag: string
  rental_tag_state: string
  air_flight1: string
  air_flight2: string
  air_destination: string
  receipt_status: string
}

interface Props {
  case_record: CaseRecord
  expense: ExpenseRecord
  users: { id: number; name: string }[]
  expense_types: { id: number; name: string }[]
  errors?: Record<string, string[]>
}

export default function New({
  case_record,
  expense,
  users,
  expense_types,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Cases", href: "/cases" },
    {
      title: case_record.display_name || case_record.case_number,
      href: `/cases/${case_record.id}`,
    },
    { title: "Expenses", href: `/cases/${case_record.id}/expenses` },
    { title: "New", href: `/cases/${case_record.id}/expenses/new` },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`New Expense - ${case_record.case_number}`} />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">New Expense</h1>

        <div className="rounded-lg bg-white p-6 shadow">
          <ExpenseForm
            caseId={case_record.id}
            expense={expense}
            users={users}
            expenseTypes={expense_types}
            errors={errors}
            onCancel={() => router.get(`/cases/${case_record.id}/expenses`)}
          />
        </div>
      </div>
    </AppLayout>
  )
}
